<div class="input-wrapper">
    <form class="search" role="search">
        <input class="form-control me-2 {{customeClassName}}" type="search" placeholder="{{placeholderLevel}}"
            aria-label="Search" />
    </form>
</div>